export const productDefault = {
  editionPrice: { variant: {}, inventory: {} },
  editPriceModalVisibility: false,
  isChangingAvailability: false,
  isChangingPromotion: false,
}

const setProductEditionPrice = (state, value) => ({
  ...state,
  editionPrice: value,
})

const setEditModalVisibility = (state, value) => ({
  ...state,
  editPriceModalVisibility: value,
})

const setIsChangeAvailability = (state, value) => ({
  ...state,
  isChangingAvailability: value,
})

const setIsChangePromotion = (state, value) => ({
  ...state,
  isChangingPromotion: value,
})

const productActions = {
  PRODUCT_EDITION_PRICE: setProductEditionPrice,
  EDIT_MODAL_VISIBILITY: setEditModalVisibility,
  CHANGE_AVAILABILITY: setIsChangeAvailability,
  CHANGE_PROMOTION: setIsChangePromotion,
}

const productReducer = (state, action) => {
  return productActions[action.type](state, action.value)
}

export default productReducer
